<!-- prettier-ignore -->

<form [formGroup]="sendForm" class="form-wrapper">

   <!-- @if(isSaveRoute()){
        <h1>{{'Información para la ruta' | translate}}</h1>
        <div class="form-group-pdf" >
            <label class="labels">
                <span>{{ 'Nombre de la ruta' | translate }}</span> *
            </label>
            <input #input autocomplete="off" (focusin)="focusin($event)" type="text" formControlName="routeName" (keyup)="insertText(input.value)" />
        </div>

        <div class="form-group-pdf" >
            <label class="labels">{{ 'Información Adicional' | translate }}</label>
            <textarea autocomplete="off" formControlName="additionalInfo" rows="10"></textarea>
        </div>
   }
   @else{ -->
        <h1>{{'Información para el turista' | translate}}</h1>
        <div class="form-group-pdf" >
            <label class="labels">
                <span>{{ 'Nombre' | translate }}</span> *
            </label>
            <div class="input-wrapper">
                @if(!isTechMode()){
                    <input autocomplete="off" (focusin)="focusin($event)" type="text" formControlName="name" />
                }
                @else {
                    <input autocomplete="off" (focusin)="focusin($event)" [type]="hideName() ? 'password' : 'text'" formControlName="name" />
                    <ion-icon (click)="toggleNameVisibility()" class="show-button-icon" [name]="hideName() ? 'eye-off' : 'eye'"></ion-icon>
                }
            </div>
        </div>

        <div class="form-group-pdf" >
            <label class="labels">
                <span>{{ 'Email' | translate }}</span> *
            </label>
            <div class="input-wrapper">
                @if(!isTechMode()){
                    <input autocomplete="off" (focusin)="focusin($event)" type="text"  formControlName="email" />
                }
                @else {
                    <input autocomplete="off" (focusin)="focusin($event)" [type]="hideEmail() ? 'password' : 'text'"  formControlName="email" />
                    <ion-icon (click)="toggleEmailVisibility()" class="show-button-icon" [name]="hideEmail() ? 'eye-off' : 'eye'"></ion-icon>
                }
            </div>
        </div>

        <!-- <div class="form-group-pdf" >
            <label class="labels">{{ 'Información Adicional' | translate }}</label>
            <textarea autocomplete="off" formControlName="additionalInfo" rows="10"></textarea>
        </div> -->

        <div class="form-group-pdf" >
            <div class="conditions-block" >
                <input (focusin)="focusin($event)" formControlName="acceptConditions" type="checkbox" class="inputs-checkbox-conditions" />
                <span class="check-conditions"></span>
                <label class="labelConditions">
                    <span (click)="openPrivacyModal()">{{ 'He leído y acepto los términos y condiciones de uso' | translate }}</span> *
                </label>
            </div>                
        </div>
   <!-- } -->

   @if(!authService.userValue && registerAfter() && !isInfoRoutePage()){
    <cicerone-registers-after-before [registerData]="registerAfter()" [isAfter]="true" style="width: 100%;"></cicerone-registers-after-before>
   }

   <div class="send-buttons-container">
        @if(!isInfoRoute())  {
            <button (click)="goBack()" type="button" class="back-button">{{ "Volver" | translate }}</button>
        }

        <button (click)="sendRoute()" class="send-button" [ngClass]="{'loader' : sendingMail()}" [disabled]="sendingMail()">
            @if(sendingMail()){
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style="height: 40px; width: 40px; position: absolute;">
                    <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                        <stop offset="0" stop-color="#FFFFFF"></stop>
                        <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
                        <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
                        <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
                        <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
                    </radialGradient>
                    <circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="40" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
                        <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
                    </circle>
                    <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="40" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                </svg>
            }
            @else {
                {{(!isSaveRoute() ? 'Enviar' : 'Guardar') | translate}}            
            }
        </button>

    </div>
   


</form>